module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step1_Image20.73b67411.jpg";